import axios, {AxiosInstance, AxiosRequestConfig} from "axios";

const config: AxiosRequestConfig = {
    headers: {
        Accept: "application/json",
        'content-type': 'application/json',
    }
}

const api: AxiosInstance = axios.create(config)

export default api